import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from '@/i18n'


import { NavBar, Button, Dialog, Image as VanImage, Loading, Notify, Empty, Overlay, ImagePreview, List, Popup } from 'vant';


import 'vant/lib/index.css';

Vue.use(NavBar);
Vue.use(Button);
Vue.use(Dialog);
Vue.use(VanImage);
Vue.use(Loading);
Vue.use(Notify);
Vue.use(Overlay);
Vue.use(ImagePreview);
Vue.use(Empty);
Vue.use(List);
Vue.use(Popup);



import "@/assets/scss/style.scss";

export const eventBus = new Vue(); // creating an event bus.


new Vue({
    el: "#app",
    router: router,
    store,
    i18n,
    render: h => h(App),
})


